import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'miq-property-set-info-dialog',
  templateUrl: './property-set-info-dialog.component.html',
  styleUrls: ['./property-set-info-dialog.component.scss'],
  standalone: false,
})
export class PropertySetInfoDialogComponent implements OnInit, OnDestroy {
  constructor(
    private dialogRef: MatDialogRef<PropertySetInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    /* required for static lable translation */
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
